import { Reveal } from '@/components/motion/Reveal'
import { SectionHeading } from '@/components/ui/SectionHeading'
import { TiltCard } from '@/components/motion/TiltCard'
import { useTranslations } from '@/app/site-context'

export function Why() {
  const { why } = useTranslations()

  return (
    <section className="why section" id="why" aria-labelledby="why-title">
      <SectionHeading title={why.title} id="why-title" index="01" />
      <ul className="why__grid">
        {why.cards.map((card, index) => (
          <li key={card.title}>
            <Reveal variant="clip" delay={index * 110}>
              <TiltCard className="why__card" intensity={6}>
                <span
                  className="why__index"
                  data-index={String(index + 1).padStart(2, '0')}
                  aria-hidden="true"
                />
                <span className="why__marker" aria-hidden="true" />
                <h3 className="why__title">{card.title}</h3>
                <p className="why__body">{card.body}</p>
              </TiltCard>
            </Reveal>
          </li>
        ))}
      </ul>
    </section>
  )
}
